import ViewEmployees from "../ViewEmployees";

export default function ConvertedEmployees() {
    return (
        <>
            <ViewEmployees isProbation={true} />
        </>
    )
}